import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EMPTY, of } from "rxjs";
import {
  catchError,
  concatMap,
  filter,
  map,
  withLatestFrom,
} from "rxjs/operators";
import { PackagesService } from "src/app/shared/services/admin/packages.service";
import {
  loadPackageListFailure,
  packageListLoad,
  packageListLoadSuccess,
  packageLoad,
} from "../../actions/packages/packages.actions";

import { Package } from "src/app/shared/interfaces/packages/package";
import { Store } from "@ngrx/store";
import { PackageListState } from "../../reducers/packages/packages.reducer";
import { adminPackagesSelector } from "../../selectors/course-admin.selectors";

@Injectable()
export class PackagesEffect {
  getPackageList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(packageListLoad),
      concatMap((param) => {
        return this.packagesService.getPackages(param.id).pipe(
          map((res: Package[]) => packageListLoadSuccess({ packages: res })),
          catchError(({ error }) => of(loadPackageListFailure(error))),
        );
      }),
    ),
  );

  getSinglePackage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(packageLoad),
      withLatestFrom(this.store.select(adminPackagesSelector.selectEntities)),
      concatMap(([param, packages]) => {
        const existingPackage: Package = packages[param.packageId];
        if (existingPackage) {
          return EMPTY;
        }
        return this.packagesService
          .getSinglePackage(param.organizationId, param.packageId)
          .pipe(
            map((res: Package) => packageListLoadSuccess({ packages: [res] })),
            catchError(({ error }) => of(loadPackageListFailure(error))),
          );
      }),
    ),
  );

  constructor(
    private packagesService: PackagesService,
    private actions$: Actions,
    private store: Store<{ packages: PackageListState }>,
  ) {}
}
